module.exports = __webpack_public_path__ + "static/media/capgemini.a9d1c00c.png";